export interface IApiCompetitionItem {
  CompetitionID?: number;
  Classification?: string;
  Category?: string;
  Sponsor?: string;
  Title?: string;
  TitleShort?: string;
  Description?: string;
  DescriptionShort?: string;
  DescriptionTiny?: string;
  Prize?: string;
  QuestionBlurb?: string;
  Question?: string;
  ImageName?: string;
  TermsCondition?: string;
  StartDate?: string | null;
  EndDate?: string | null;
}

export default class CompetitionItem {
  id: number;
  classification: string;
  category: string;
  sponsor: string;
  title: string;
  titleShort: string;
  desc: string;
  descShort: string;
  descTiny: string;
  prize: string;
  questionBlurb: string;
  question: string;
  imageName: string;
  termsCondition: string;
  startDate: string | null;
  endDate: string | null;

  constructor() {
    this.id = 0;
    this.classification = '';
    this.category = '';
    this.sponsor = '';
    this.title = '';
    this.titleShort = '';
    this.desc = '';
    this.descShort = '';
    this.descTiny = '';
    this.prize = '';
    this.questionBlurb = '';
    this.question = '';
    this.imageName = '';
    this.termsCondition = '';
    this.startDate = null;
    this.endDate = null;
  }

  static mappingPropertyObject(object: IApiCompetitionItem): CompetitionItem {
    const newObject = new CompetitionItem(); // Created class instance instead of generic object
    newObject.id = object.CompetitionID || 0;
    newObject.classification = object.Classification || '';
    newObject.category = object.Category || '';
    newObject.sponsor = object.Sponsor || '';
    newObject.title = object.Title || '';
    newObject.titleShort = object.TitleShort || '';
    newObject.desc = object.Description || '';
    newObject.descShort = object.DescriptionShort || '';
    newObject.descTiny = object.DescriptionTiny || '';
    newObject.prize = object.Prize || '';
    newObject.questionBlurb = object.QuestionBlurb || '';
    newObject.question = object.Question || '';
    newObject.imageName = object.ImageName || '';
    newObject.termsCondition = object.TermsCondition || '';
    newObject.startDate = object.StartDate || null;
    newObject.endDate = object.EndDate || null;

    return newObject;
  }
}
